module.exports = __webpack_public_path__ + "media/images/icon-close-58aba2d56cfe13feaeb31713d441273c.svg";